<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="title-number lightblue--text font-weight-bold">01</span>
        <span class="title lightblue--text font-weight-bold">Tomador</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p
          class="subheading font-weight-bold"
          v-html="formatCNPJ(tomador.cnpj_cpf)"
        />
        <p class="subheading font-weight-bold" v-html="tomador.nome" />
        <p
          class="subheading font-weight-bold"
          v-html="formatAddress(tomador.endereco)"
        />
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title>
        <span class="title-number lightblue--text font-weight-bold">02</span>
        <span class="title lightblue--text font-weight-bold">Segurado</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p
          class="subheading font-weight-bold"
          v-html="
            segurado.cnpj_cpf.length > 11
              ? formatCNPJ(segurado.cnpj_cpf)
              : formatCPF(segurado.cnpj_cpf)
          "
        />
        <p class="subheading font-weight-bold" v-html="segurado.nome" />
        <p
          class="subheading font-weight-bold"
          v-html="formatAddress(segurado.endereco)"
        />
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title>
        <span class="title-number lightblue--text font-weight-bold">03</span>
        <span class="title lightblue--text font-weight-bold">Modalidade</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
              class="jns-input"
              label="Grupo"
              v-if="modalidades && modalidades.grupo"
              v-model="modalidades.grupo"
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              class="jns-input"
              label="Principal"
              v-if="modalidades && modalidades.principal"
              v-model="modalidades.principal"
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-text-field
              class="jns-input"
              label="Complementar"
              v-if="modalidades && modalidades.complementar"
              v-model="modalidades.complementar"
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-for="(cobertura, index) in coberturas"
          :key="index"
        >
          <v-flex v-if="cobertura.tipo == 'adicional'">
            <v-text-field
              class="jns-input"
              label="Coberturas Adicionais"
              v-model="cobertura.nome"
              disabled
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title>
        <span class="title-number lightblue--text font-weight-bold">04</span>
        <span class="title lightblue--text font-weight-bold"
          >Informações da Garantia</span
        >
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-layout
          row
          wrap
          v-for="(cobertura, index) in coberturas"
          :key="index"
        >
          <v-flex xs6>
            <v-text-field
              class="jns-input"
              :label="
                cobertura.tipo == 'basica'
                  ? 'Modalidade Principal'
                  : cobertura.tipo == 'corretiva'
                  ? 'Modalidade Complementar'
                  : 'Modalidade Adicional'
              "
              v-model="cobertura.nome"
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>

          <v-flex xs2>
            <v-text-field
              class="jns-input"
              label="Importância Segurada"
              :value="
                cobertura.importancia_segurada
                  ? cobertura.importancia_segurada.toLocaleString(
                      'pt-BR',
                      moneyFormatOptions
                    )
                  : cobertura.importancia_segurada
              "
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              class="jns-input"
              label="Início Vigência"
              v-model="cobertura.inicio_vigencia_formatted || cobertura.inicio_vigencia"
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              class="jns-input"
              label="Final Vigência"
              v-model="cobertura.fim_vigencia_formatted || cobertura.fim_vigencia"
              disabled
              placeholder=" "
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 class="jns-input">
            <label>Objeto</label>
            <p v-html="textProposal"></p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang='scss' scoped>
.title-number {
  font-size: 22px;
}
.title {
  margin-left: 10px;
}
</style>

<script lang="js">
import { formatCNPJ, formatCPF, formatAddress } from "@/libs/utils";
import moment from "moment";

export default {
  name: "PropostaExpandidaInformacoes",
  data: () => ({
    formatCNPJ,
    formatCPF,
    formatAddress,
    drawer: null,
    moneyFormatOptions: false,
  }),
  mounted() {
    // não sei porque preciso fazer isso mas preciso
    this.moneyFormatOptions = this.$settings.moneyFormatOptions;
  },
  computed: {
    textProposal() {
      return this.objeto ? this.objeto.replace(/(?:\r\n|\r|\n|\\r\\n)/g, '<br />') : "";
    }
  },
  props: ["modalidades", "tomador", "segurado", "coberturas", "tags", "objeto"],
};
</script>



// WEBPACK FOOTER //
// ./src/components/PropostaExpandidaInformacoes.vue